import * as React from 'react'

import FromTo from 'components/FromTo'
import { Modal, ModalFooter, ModalHeader } from 'components/Modal'

import { DisplayContent } from 'react-content-engine'
import Content from '../../pages/shared/content'

import { SRPRS } from 'Icon/srprs'
import { SRPRS_ENV } from '../../env'

export interface WarningStateProps {
  oldSecondary: any
}

export interface WarningDispatchProps {
  onChangePrimary: (value: any) => void
  onChangeSecondary: (value: any) => void
}

export interface WarningOwnProps {
  newPrimary: any
  newSecondary: any
  icon: JSX.Element
  iconProps?: object
  formatSecondary: (value: any) => string | JSX.Element
  onClose?: () => void
}

interface WarningProps
  extends WarningStateProps,
    WarningDispatchProps,
    WarningOwnProps {}

export class WarningModal extends React.Component<WarningProps, {}> {
  constructor(props: WarningProps) {
    super(props)
    this.handleYes = this.handleYes.bind(this)
    this.handleNo = this.handleNo.bind(this)
  }

  public handleNo() {
    if (this.props.onClose !== undefined) {
      this.props.onClose()
    }
  }

  public handleYes() {
    this.props.onChangePrimary(this.props.newPrimary)
    this.props.onChangeSecondary(this.props.newSecondary)
    this.handleNo()
  }

  public render() {
    return (
      <Modal
        onDismiss={this.handleNo}
        size="xl"
        sticky={true}
        color={false}
        disableOutsideClick={SRPRS_ENV === 'editable'}
        modalName={`warningModal`}
      >
        <ModalHeader
          icon={SRPRS.mapMarkerColored}
          iconProps={{
            width: '37',
            height: '37',
            viewBox: '0 0 37 41',
            fill: 'none',
          }}
        >
          <Content contentKey="are-you-sure">Are you sure?</Content>
        </ModalHeader>
        <div className="content">
          <div className="margin-b-m">
            <small>
              <Content contentKey="you-will-change">
                You will change something to the present composition of your
                trip
              </Content>
            </small>
          </div>

          <FromTo
            fromSubject={
              <Content contentKey="previous-state">Previous State</Content>
            }
            fromIcon={this.props.icon}
            fromIconProps={this.props.iconProps}
            fromAnswer={this.props.formatSecondary(this.props.oldSecondary)}
            toSubject={<Content contentKey="new-state">New State</Content>}
            toIcon={this.props.icon}
            toIconProps={this.props.iconProps}
            toAnswer={this.props.formatSecondary(this.props.newSecondary)}
          />
        </div>
        <ModalFooter
          onClose={this.handleNo}
          onSave={this.handleYes}
          closeText={
            <DisplayContent edit={true} contentKey="nope-rather-not">
              Nope, rather not
            </DisplayContent>
          }
          saveText={
            <DisplayContent edit={true} contentKey="yes-save">
              Yes, save
            </DisplayContent>
          }
        />
      </Modal>
    )
  }
}
